"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.entries");
var _inOutBound = require("@/api/inOutBound");
var _merchant = require("@/api/merchant");
var _MerchantFilter = _interopRequireDefault(require("../components/MerchantFilter.vue"));
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  // 给props的title_prfix加上默认值
  props: ['selectedItem'],
  components: {
    MerchantFilter: _MerchantFilter.default
  },
  data: function data() {
    var _this = this;
    var validateLicensePlate = function validateLicensePlate(rule, value, callback) {
      if (_this.formData.is_registered == 1 && !value) {
        callback(new Error('请输入车牌'));
      } else {
        callback();
      }
    };
    return {
      btn_disabled: false,
      dialogVisible: false,
      formData: {
        id: undefined,
        name: '',
        purchase_price: undefined,
        //进货价格
        repair_price: undefined,
        //修理价格
        quantity: undefined,
        //数量
        // cost_count: '', //消耗数量
        remark: ''
      },
      defaultForm: {
        id: undefined,
        name: '',
        purchase_price: undefined,
        //进货价格
        repair_price: undefined,
        //修理价格
        quantity: undefined,
        //数量
        // cost_count: '', //消耗数量
        remark: ''
      },
      userType: 0,
      rules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        purchase_price: [{
          required: true,
          message: '请输入进货价格',
          trigger: 'blur'
        }],
        repair_price: [{
          required: true,
          message: '请输入修理价格',
          trigger: 'blur'
        }],
        quantity: [{
          required: true,
          message: '请输入数量',
          trigger: 'blur'
        }],
        // cost_count: [{ required: true, message: '请输入消耗数量', trigger: 'blur' }],
        remark: [{
          required: false,
          message: '请输入备注',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    // 写一个计算属性，根据props传来的title值，得到新增转账记录还是编辑
    dialogTitle: function dialogTitle() {
      return Object.entries(this.selectedItem).length ? '编辑入库信息' : '添加入库信息';
    },
    isTextarea: function isTextarea() {
      return Object.entries(this.selectedItem).length ? '' : 'textarea';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        var merchantId = (0, _auth.getMerchantId)();
        this.userType = merchantId == 0 ? 0 : 1; // 如果商户ID为0，则表示供应商，否则表示商户

        this.formData = Object.assign(this.formData, this.selectedItem);
        console.log('cx', this.formData);
        console.log('this.userType', this.userType);
        // 将两个对象的内容合并
      } else {
        console.log('关闭');
        this.$refs['formDataRef'].resetFields();
        this.formData = Object.assign(this.formData, this.defaultForm);
        console.log('this.formData', this.formData);
      }
    }
  },
  methods: {
    handleMerchantSelected: function handleMerchantSelected(val) {
      console.log('handleMerchantSelected', val);
      this.formData.merchantId = val;
    },
    submit: function submit() {
      var _this2 = this;
      // this.$confirm("您确定要申请扣款吗？", "申请扣款", {
      // 	confirmButtonText: '确定',
      // 	cancelButtonText: '取消'
      // }).then(() => {
      this.$refs['formDataRef'].validate(function (valid) {
        console.log('valid', valid);
        console.log('this.formData', _this2.formData);
        if (valid) {
          var param = (0, _objectSpread2.default)({}, _this2.formData);
          console.log('最终参数', param);
          // return;
          _this2.btn_disabled = true;
          (0, _inOutBound.editInBoundPart)(param).then(function (res) {
            _this2.$emit('getList');
            _this2.close();
          }).catch(function () {}).finally(function () {
            console.log('finally');
            _this2.btn_disabled = false;
            _this2.$refs['formDataRef'].resetFields();
            _this2.formData = Object.assign(_this2.formData, _this2.defaultForm);
          });
        }
      });
    },
    close: function close() {
      this.dialogVisible = false;
    }
  }
};
exports.default = _default;